const Ext = require('ext')
const t = require('translate')
const ActionClause = require('smartrules/designer/ActionClause')

const Whitelist = Ext.define(null, {
  extend: ActionClause,

  constructor(cfg = {}) {
    cfg = Ext.applyIf(cfg, {
      label: t('Whitelist'),
      type: 'smartrules-whitelist'
    })
    this.callParent([cfg])
  },

  toDsl() {
    return 'whitelist'
  }
})

module.exports = Whitelist
